import languageEnglish from "common/translations/daffi_en.json";
import languageSpain from "common/translations/daffi_es.json";
import languageFrance from "common/translations/daffi_fr.json";
import languagePortugal from "common/translations/daffi_pt.json";
import languageGerman from "common/translations/daffi_de.json";

const Translations = { en: languageEnglish, fr: languageFrance, es: languageSpain, pt: languagePortugal, de: languageGerman };

export default Translations;
